export const FinPlatformTexts = {
  title: 'Сравни.ру — лицензированная финансовая платформа',
  subTitle: 'Включена в реестр операторов финансовых платформ Банка России с 26 августа 2021 г.',
  federalLawNotice:
    'Мы работаем по лицензии ЦБ РФ в соответствии с Федеральным законом №211-ФЗ. Это означает, что вы можете оформить кредит или займ прямо на нашей платформе — без переходов на сторонние сайты, с полной защитой ваших данных и средств.',
  finOrgText:
    'АО «Финансовый Маркетплейс Сравни.ру» · ОГРН 1207700502107 · ИНН 9705151291. ООО «Сравни.ру» · ИНН 7710718303 · ОГРН 1087746642774 — витрина-агрегатор, обеспечивающая информацию о предложениях финансовых организаций на совершение сделок с использованием финансовой платформы',
  finOrgUrlLabel: 'Проверьте в реестре ЦБ',
};
